import mustache from 'mustache';
import { closeDialogOnBackdropClick } from './dialog-helper.js';

/**
 * Mustache template for the video dialog.
 */
const videoDialogTemplate = `
<dialog class="video-dialog">
  <div class="video-container">
    <button class="close hedin-btn hedin-btn--tertiary f-icon f-icon--align-right f-icon--x hedin-btn--no-bg-hover-effects">Sulje</button>
  </div>
</dialog>
`;

/**
 * VideoDialog class open a video in a dialog element. 
 * To show a video media file it has to be in a video element, for this reason we need a two separated video elements in
 * a dom after we open the dialog. 
 * 
 * Template on Stage: 
 * [mustache / Hedin / Components / 2024 / VideoModal](https://laakkonen.stage.crasman.cloud/admin/manage/scriptlets/scriptleteditor/html/code/show/Y_t0YbPlQ3mbL13DdkbQuQ)
 */
export default class VideoDialog {

  /**
   * Components DOM references.
   */
  #dom = {};

  /**
   * @constructor
   * @param {HTMLDivElement} element - Container class
   */
  constructor(element) {
    this.#dom.element = element;
    this.findElements();
    this.addEventListeners();
  }

  /**
   * Find all the necessary elements for the component.
   */
  findElements() {
    this.#dom.button = this.#dom.element.querySelector('button');
    this.#dom.video = this.#dom.element.querySelector('video');
  }

  /**
   * Add event listeners to the component.
   */
  addEventListeners() {
    this.#dom.button.addEventListener('click', this.openDialog.bind(this));
  }

  /**
   * Create the dialog element and append it to the DOM.
   */
  createDialog() {
    const html = mustache.render(videoDialogTemplate, {});
    this.#dom.element.insertAdjacentHTML('beforeend', html);
    this.#dom.dialog = this.#dom.element.querySelector('dialog');
    this.#dom.dialogVideoContainer = this.#dom.dialog.querySelector('.video-container');

    this.#dom.dialog.addEventListener('close', (event) => {
      this.closeDialog();
    });

    this.#dom.dialog.querySelector('button.close').addEventListener('click', (event) => {
      this.closeDialog();
    });

    this.#dom.dialog.addEventListener('click', (event) => {     
      if( event.target.tagName !== 'VIDEO') {
        closeDialogOnBackdropClick(event, this.#dom.dialogVideoContainer, this.#dom.dialog);
        this.closeDialog();
      }
    });

    // Move video element to dialog    
    this.#dom.dialogVideo = this.#dom.video.cloneNode(true);
    this.#dom.dialog.querySelector('.video-container').appendChild(this.#dom.dialogVideo);
  }

  /**
   * Close the dialog and pause the video.
   */
  closeDialog() {
    this.#dom.dialogVideo.pause();// Pause the video when the dialog is closed
    this.#dom.dialog.close();
    this.#dom.dialog.classList.remove('show');
    this.#dom.dialogVideo.controls = false;
  }

  /**
   * Open the dialog and play the video.
   */
  openDialog() {
    if ( window.innerWidth > 844 ) {
      if( !this.#dom.dialog ) {
        this.createDialog();
      }
  
      this.#dom.dialog.classList.add('show');
      this.#dom.dialog.showModal();
      this.#dom.dialogVideo.play();
      this.#dom.dialogVideo.controls = true;
    } else {// Just let the video play in mobile devices
      this.#dom.video.controls = true;
      this.#dom.video.play();      
    }
  }
  
}